<ngx-loading-bar [color]="'#ca26d9'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar>
<app-loader *ngIf="show"></app-loader>
<router-outlet></router-outlet>